
import React from 'react'
import { useTranslation } from "react-i18next";
const Intial = () => {
    const { t } = useTranslation()
    return (
        <div>
            <h1 className='font-medium text-[17px] text-[#fff] leading-[26px]'>
                {t(`l4-0-desc1`)}
            </h1>
            <h1 className='font-medium text-[17px] text-[#fff] mt-2 leading-[26px]'>
                {t(`l4-0-desc2`)}
            </h1>

        </div>
    )
}

export default Intial
